import React from "react";
import banner7 from "../assets/banner7.jpg"; // replace with actual image path

export default function LegalRegulatoryAdvisory() {
  return (
    <section className="py-5">

      {/* Heading */}
      <div className="text-center mb-3">
        <h2 className="main-section-title fw-bold">Legal & Regulatory Advisory</h2>
        <p className="text-muted small">
          Guiding compliance and statutory adherence across organisations.
        </p>
      </div>

      {/* Image */}
      <div className="mb-4">
        <img 
          src={banner7} 
          alt="Legal & Regulatory Advisory" 
          className="img-fluid rounded w-100"
        />
      </div>

      {/* Elaborative Text */}
      <div className="container">
        <p className="text-muted fs-6">
          Zamani Sabios Group provides legal and regulatory advisory services, 
          ensuring organisations comply with statutory requirements and sector rules. 
          We guide public, private, and nonprofit institutions on regulations, 
          policy interpretation, and operational compliance. Our practical, evidence-based 
          approach helps organisations manage risk, avoid legal challenges, and operate 
          efficiently within legal frameworks.
        </p>
      </div>

    </section>
  );
}
